import React, { useState } from "react";
import {
  IonRow,
  IonCol,
  IonItem,
  IonInput,
  IonButton,
  IonModal,
  IonToolbar,
  IonButtons,
  IonHeader,
  IonTitle,
  IonLabel
} from "@ionic/react";
import { supabase } from "../../../hooks/supabase";
import useUser from "../../../hooks/user/getUser";
import { useParams } from "react-router";



const UpdateDogForm: React.FC = (props) => {
  console.log(props);

  const [editing, setEditing] = useState();
  const [name, setName] = useState(props.dog[0].name);
  const [race, setRace] = useState(props.dog[0].race);
  const [birthday, setBirthday] = useState(props.dog[0].birthday);
  const [colour, setColour] = useState(props.dog[0].colour)
  const params = useParams();
  const { user, setUser } = useUser();
  const [isOpen, setIsOpen] = useState(true);

  async function updateDog() {
    try {
      const { data, error } = await supabase
        .from("commands")
        .update({
          name: name,
          race: race,
          birthday: birthday,
          colour: colour
        })
        .eq('id', params.id)
      if (error) throw error;
      console.log("inserted")
      window.location.reload();
    } catch (error) {
      console.log(error.message);
    }
  }

  return (
    <>
      <IonModal isOpen={isOpen}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>Modal</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => {
                setIsOpen(false);
                setEditing(false)
              }}>Close</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonRow>
          <IonCol>
            <IonItem>
              <IonLabel>Name</IonLabel>
              <IonInput
                label="Name"
                labelPlacement="stacked"
                name="name"
                clearInput={true}
                value={name}
                onIonChange={(e: any) => {
                  console.log(e.detail.value)
                  setName(e.detail.value);
                  console.log(name);
                }}



              >
              </IonInput>
            </IonItem>
          </IonCol>
        </IonRow>

        <IonRow>
          <IonCol>
            <IonItem>
              <IonLabel>Race</IonLabel>
              <IonInput
                type="text"
                name="race"
                clearInput={true}
                value={race}
                onIonChange={(e: any) => {
                  console.log(e.detail.value)
                  setRace(e.detail.value);
                }}
              >
              </IonInput>
            </IonItem>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol>
            <IonItem>
              <IonLabel>Birthday</IonLabel>
              <IonInput
                type="date"
                name="birthday"
                clearInput={true}
                value={birthday}
                onIonChange={(e: any) => {
                  console.log(e.detail.value)
                  setBirthday(e.detail.value);
                }}
              >
              </IonInput>
            </IonItem>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol>
            <IonItem>
              <IonLabel>Colour</IonLabel>
              <IonInput
                type="text"
                name="colour"
                clearInput={true}
                value={colour}
                onIonChange={(e: any) => {
                  console.log(e.detail.value)
                  setColour(e.detail.value);
                }}
              >
              </IonInput>
            </IonItem>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol>
            <IonButton expand="block" onClick={() => updateDog()}>Send</IonButton>

          </IonCol>
        </IonRow>
      </IonModal>

    </>
  );
}

export default UpdateDogForm;